const ABSOLUTE_URL_PATTERN = /^(https?:)?\/\//i;

function trimTrailingSlash(value = '') {
  return value.replace(/\/+$/, '');
}

function trimLeadingSlash(value = '') {
  return value.replace(/^\/+/, '');
}

export function normalizeMediaBaseUrl(base) {
  return trimTrailingSlash((base || '').trim());
}

export function resolveMediaUrl(pathOrUrl, base) {
  if (!pathOrUrl || ABSOLUTE_URL_PATTERN.test(pathOrUrl) || pathOrUrl.startsWith('data:')) {
    return pathOrUrl;
  }

  const normalizedBase = normalizeMediaBaseUrl(base);
  if (!normalizedBase) {
    return pathOrUrl;
  }

  return `${normalizedBase}/${trimLeadingSlash(pathOrUrl)}`;
}

export function resolveSharedVideoPath(filename, base) {
  if (!filename || ABSOLUTE_URL_PATTERN.test(filename) || filename.startsWith('data:')) {
    return filename;
  }

  const normalizedBase = normalizeMediaBaseUrl(base);
  if (!normalizedBase) {
    return filename;
  }

  const normalizedFilename = trimLeadingSlash(filename).split('/').pop();
  return resolveMediaUrl(`shared/videos/${normalizedFilename}`, normalizedBase);
}

export function mapSharedVideoPlaylist(relativePaths, base) {
  return relativePaths.map(path => resolveSharedVideoPath(path, base));
}
